import * as types from './mutation-types'

export default {
    [types.SET_PRODUCTS](state, products) {
        state.products = products
    },
    [types.LOAD_CATEGORIES_WITH_PRODUCTS](state, categoriesWithProducts) {
        state.categoriesWithProducts = categoriesWithProducts
    },
    SET_LOADING(state, loading) {
        state.loading = loading
    },
    SET_ERROR(state, error) {
        state.error = error
    },
    SET_CURRENT_SHOP(state, shopId) {
        state.currentShopId = shopId
    },
    SET_CATEGORIES(state, categories) {
        state.categories = categories
    },
    [types.SET_PAYMENT_METHODS](state, paymentMethods) {
        state.paymentMethods = paymentMethods
    },
    [types.SET_CUSTOMERS](state, customers) {
        state.customers = customers
    },

    // Multi-cart mutations
    [types.ADD_CART](state) {
        state.carts.push({ items: [], selectedClient: null })
        state.activeCartIndex = state.carts.length - 1
    },
    [types.REMOVE_CART](state, index) {
        if (state.carts.length <= 1) return
        state.carts.splice(index, 1)
        if (state.activeCartIndex >= state.carts.length) {
            state.activeCartIndex = state.carts.length - 1
        } else if (state.activeCartIndex > index) {
            state.activeCartIndex--
        }
    },
    [types.SET_ACTIVE_CART_INDEX](state, index) {
        if (index >= 0 && index < state.carts.length) {
            state.activeCartIndex = index
        }
    },
    [types.ADD_TO_CART](state, product) {
        const cart = state.carts[state.activeCartIndex]
        const existing = cart.items.find(i => i.id === product.id)
        if (existing) {
            existing.quantity++
        } else {
            cart.items.push({ ...product, quantity: 1, discount: 0, originalPrice: product.price })
        }
    },
    [types.UPDATE_CART_ITEM](state, { index, item }) {
        const cart = state.carts[state.activeCartIndex]
        cart.items.splice(index, 1, item)
    },
    [types.REMOVE_FROM_CART](state, productId) {
        const cart = state.carts[state.activeCartIndex]
        cart.items = cart.items.filter(i => i.id !== productId)
    },
    [types.CLEAR_ACTIVE_CART](state) {
        state.carts[state.activeCartIndex].items = []
    },
    [types.SET_SELECTED_CLIENT](state, client) {
        state.carts[state.activeCartIndex].selectedClient = client
    },
    [types.SET_CART_ITEMS](state, items) {
        state.carts[state.activeCartIndex].items = items
    },

    // Backward compat aliases
    setCart(state, cart) {
        state.carts[state.activeCartIndex].items = cart
    },
    clearCart(state) {
        state.carts[state.activeCartIndex].items = []
    },
}
